import { ensureRemoteTranslation } from "Utils/translationLoader"
import { getTranslation, getTranslationString } from "Utils/getTranslation"

const DEFAULT_LANG = 0

const safeLanguageId = langageId => {
  if (langageId === undefined || langageId === null) return DEFAULT_LANG
  return langageId
}

const ensureRemote = async langageId => {
  try {
    await ensureRemoteTranslation(langageId)
  } catch (error) {
    console.warn("[i18n] ensureRemoteTranslation failed", error)
  }
}

export async function loadSagaTranslation(langageId) {
  const sanitized = safeLanguageId(langageId)
  await ensureRemote(sanitized)
  return getTranslation(sanitized) || {}
}

export async function loadSagaTranslationString(code, langageId) {
  const sanitized = safeLanguageId(langageId)
  await ensureRemote(sanitized)
  return getTranslationString(code, sanitized)
}

